import { Component, Vue } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'
import { IUsersServices } from '@/types';

@Component({
  components: {
    Multiselect,
  }
})

export default class RemoveUser extends Vue {

  private namespace: string = '/Console';

  private user: IUsersServices | null = null;

  private alertMessage: string = '';

  private error: boolean = false;

  private get Users () {
      
    return this.$store.state.session.services.map((service: IUsersServices) => (
      
      {label: service.displayName, userId: service.userId}
    ));
  }

  private alertReset () {
    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async remove () {

    try {

      if (this.user != null) {
        
        const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/RemoveUser?userId=${this.user.userId}`);

        this.alertMessage = 'User successfully removed.';
        this.alertReset();
        return;
      }

      throw new Error('Please select a user to be removed.');

    } catch (err) {

      this.error = !this.error;
      this.alertMessage = 'Ooops... Something went wrong.';
      this.alertReset()
    }
  }
}